// Дженерик (единый сетлист, фаза 1): и `SetlistSummary` (сетлист со звуком),
// и строка вкладки «Сетлисты» (`LibrarySetlistEntry`, ui/library-setlists.ts)
// несут те же два поля даты — сортировка одна на обе разновидности, вместо
// копии тела под каждую форму.
interface Dated { eventDate: string | null; createdAt: string }

/** eventDate if present, else createdAt (legacy / un-threaded rows). */
function effectiveYmd(s: Dated): string {
  return (s.eventDate ?? s.createdAt ?? '').slice(0, 10);
}

/**
 * Split setlists into upcoming (effective date >= today) and past (< today),
 * sorted upcoming-ascending (nearest service first) and past-descending
 * (most recent first). `today` is injected for testability.
 */
export function splitAndSortSetlists<T extends Dated>(
  setlists: T[],
  today: Date,
): { upcoming: T[]; past: T[] } {
  const todayYmd = today.toISOString().slice(0, 10);
  const upcoming: T[] = [];
  const past: T[] = [];
  for (const s of setlists) {
    (effectiveYmd(s) >= todayYmd ? upcoming : past).push(s);
  }
  upcoming.sort((a, b) => (effectiveYmd(a) < effectiveYmd(b) ? -1 : effectiveYmd(a) > effectiveYmd(b) ? 1 : 0));
  past.sort((a, b) => (effectiveYmd(a) > effectiveYmd(b) ? -1 : effectiveYmd(a) < effectiveYmd(b) ? 1 : 0));
  return { upcoming, past };
}
